import { PhoneCall, FileText, Truck, ShieldCheck } from "lucide-react";
import { MANIFESTO, STEPS } from "../lib/data";
import Reveal from "./Reveal";

const ICONS = [PhoneCall, FileText, Truck, ShieldCheck];

export default function Method() {
  return (
    <section id="methode" data-testid="method-section" className="bg-slate-50 py-20 md:py-28 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Steps */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Reveal>
            <span className="overline">Comment ça marche</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              De l&apos;appel à la réparation
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-24">
          {STEPS.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={step.n} delay={i * 0.1}>
                <div className="card-soft h-full p-7">
                  <div className="flex items-center justify-between">
                    <span className="h-12 w-12 rounded-2xl bg-brand/10 flex items-center justify-center">
                      <Icon className="h-6 w-6 text-brand" />
                    </span>
                    <span className="font-display font-extrabold text-4xl text-slate-200">{step.n}</span>
                  </div>
                  <h3 className="font-display font-bold text-ink text-xl mt-5">{step.title}</h3>
                  <p className="text-ink-soft mt-2 leading-relaxed">{step.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Manifesto */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <Reveal>
            <span className="overline">Notre engagement</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-3 font-display font-extrabold text-ink text-3xl md:text-5xl leading-tight">
              Pourquoi nous faire confiance
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.08}>
              <div className="card-soft h-full p-8 flex gap-6">
                <span className="font-display font-extrabold text-3xl gradient-text shrink-0">{m.n}</span>
                <div>
                  <h3 className="font-display font-bold text-ink text-xl">{m.title}</h3>
                  <p className="text-ink-soft mt-2 leading-relaxed">{m.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
